import React from "react";
import ContentPage from "./ContentPage";
import StoreLocationsGrid from "../components/storefront/StoreLocationsGrid";
import { useI18n } from "../lib/i18n";

export default function AboutPage() {
  const { t } = useI18n();
  return (
    <ContentPage
      placement="about"
      testid="page-about"
      canonicalPath="/about"
      eyebrow={t("about.eyebrow", "Atelier Di Falco")}
      title={t("about.title", "Haqqımızda")}
    >
      <StoreLocationsGrid className="mt-12 border-t border-[var(--adf-gray-5)] pt-8" />
    </ContentPage>
  );
}
